module.exports = __webpack_public_path__ + "static/simple-column-606a6b395bbb9311565e439a2a20f1bc.png";